import { preloadSpaceGuestList } from '@confluence/space-guest-list/entry-points/preloadSpaceGuestList.ts';
import { preloadShortcutsSmartLinks } from '@confluence/space-shortcuts/entry-points/preloadShortcutsSmartLinks.ts';
import { preloadSideNavigation } from '@confluence/side-navigation/entry-points/preloadSideNavigation.ts';
import { preloadSpaceViews } from '@confluence/space-views/entry-points/preloadSpaceViews.ts';
import { preloadPageTree } from '@confluence/page-tree/entry-points/preloadPageTree.ts';
import {
	isBlogTreeExpanded,
	preloadBlogTree,
} from '@confluence/blog-tree/entry-points/preloadBlogTree.ts';
import { PAGE_TREE_STATUSES } from '@confluence/page-tree/entry-points/pageTreeStatuses.ts';
import { INITIAL_PAGE_SIZE } from '@confluence/page-tree/entry-points/paginationLimits.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { preloadIsUserViewingSpaceAsAnon } from '@confluence/anonymous-access/entry-points/preloadIsUserViewingSpaceAsAnon.ts';
import { fg } from '@confluence/feature-gating';

export const preloadNavigationTasks = async (
	spaceKey: string,
	contentId: string,
	isLicensed: boolean,
	isBlog: boolean,
	previousSpaceKey?: string,
): Promise<void | any[] | Error[]> => {
	const includePageTree = Boolean(contentId) && !isBlog;
	const includeHomepageTreeVariant = !includePageTree;
	const includeBlogTreePromise = isBlog ? Promise.resolve(true) : isBlogTreeExpanded();

	return waitForAllReturnWhenError([
		preloadSpaceGuestList(spaceKey),
		fg('confluence_space_nav_core_frag_reader')
			? Promise.resolve()
			: preloadShortcutsSmartLinks(spaceKey),
		includeBlogTreePromise.then((includeBlogTree) =>
			preloadSideNavigation(spaceKey, previousSpaceKey, {
				contentId,
				includeBlogTree,
				includeHomepageTreeVariant,
				includePageTree,
				isSuperAdmin: false,
				paginationLimit: INITIAL_PAGE_SIZE,
				ptStatuses: PAGE_TREE_STATUSES,
			}),
		),
		fg('confluence_space_nav_space_views_frag_reader')
			? Promise.resolve()
			: preloadSpaceViews(spaceKey, isLicensed),
		fg('confluence_space_nav_affordances_frag_reader')
			? Promise.resolve()
			: preloadIsUserViewingSpaceAsAnon(spaceKey),
		fg('confluence_space_nav_trees_frag_reader')
			? Promise.resolve()
			: preloadPageTree({
					spaceKey,
					...(isBlog ? {} : { contentId }),
					statuses: PAGE_TREE_STATUSES,
					isSuperAdmin: false,
				}),
		fg('confluence_space_nav_trees_frag_reader')
			? Promise.resolve()
			: preloadBlogTree({ spaceKey }),
	]);
};
